import { Button, Typography } from "@mui/material";
import React from "react";
import "../assets/components/button-primary.scss";
import { ZnButton } from "./znFields/ZnButton";

const ButtonPrimary = (props) => {
  const { onClick = () => {}, disabled = false } = props; // Aggiungi la prop "disabled"

  return (
    <div
      className={props.consulenza ? "ButtonPrimaryConsulenza" : "ButtonPrimary"}
    >
      <ZnButton
        disableElevation
        {...props}
        fullWidth
        size="large"
        color="primary"
        variant="contained"
        confirmYes="Conferma"
        confirmNo="Rileggi"
        onClick={onClick}
        type="submit"
        checkbox={true}
        label="Autorizzo il deposito della denuncia in Procura, inclusi i miei dati personali, e sono consapevole che la nomina dell'avvocato è limitata al solo deposito."
        disabled={disabled}
      >
        {props.children}
      </ZnButton>
    </div>
  );
};

export default ButtonPrimary;
